import { COLORS } from '@btime/constants'
import React from 'react'

import { Text } from '../presentation/Text'
import InputWrapper from './InputWrapper'
import Link from '../actions/Link'
import Loading from '../helpers/Loading'

const InputButton = ({ onClick, loading, disabled, value, placeholder, ...props }) => {
  const handleClick = !!loading || !!disabled ? () => { } : onClick

  return (
    <Link block onClick={handleClick}>
      <InputWrapper iconSize=".9rem" iconRight={'BsCaretDown'} disabled={disabled} {...props}>
        <div className="input">
          {loading ? <Loading /> : <Text color={value ? COLORS.dark2 : COLORS.dark4}>{value || placeholder}</Text>}
        </div>
      </InputWrapper>
    </Link>
  )
}

export default InputButton
